import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";
export class userBonusPayslipUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [{
        name: 'documentDate',
        label: 'Document Date',
        type: 'date',
    }]
}
export class adminBonusPayslipUpload extends userBonusPayslipUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: dayjs('9999-12-31'),
            })
        }
    }
}